import { cloneElement } from "react";
import { saveAs } from "file-saver";
import { sum } from "lodash";

const groupByN = (arr, arrCol) => {
  const arrN = [];
  const col = arrCol.shift();
  for (const iArr of arr) {
    const f = arrN.find((it) => it[col] && it[col] === iArr[col]);
    if (f) {
      f.items.push(iArr);
    } else {
      arrN.push(col ? { [col]: iArr[col], items: [iArr] } : { ...iArr });
    }
  }
  for (const iArrN of arrN) {
    if (col && iArrN.items && iArrN.items.length !== 0) {
      const arrColN = [...arrCol];
      iArrN.items = [...(groupByN(iArrN.items, arrColN) || [])];
    }
  }

  return arrN;
};

const groupByY = (arr, arrFunc, iArrP) => {
  for (const iArr of arr) {
    if (iArr.items) {
      groupByY(iArr.items, arrFunc, iArr);

      for (const iArrFunc in arrFunc) {
        iArr[iArrFunc] = arrFunc[iArrFunc](iArr[iArrFunc]);
        if (iArrP) {
          iArrP[iArrFunc] = iArrP[iArrFunc]
            ? [...iArrP[iArrFunc], iArr[iArrFunc]]
            : [iArr[iArrFunc]];
        }
      }
    } else {
      for (const iArrFunc in arrFunc) {
        iArrP[iArrFunc] = iArrP[iArrFunc]
          ? [...iArrP[iArrFunc], iArr[iArrFunc]]
          : [iArr[iArrFunc]];
      }
    }
  }
};

const put = (arr, arrN = [], level = 0) => {
  const levelN = ++level;
  for (const iArr of arr) {
    iArr.outlineLevel = level;
    arrN.push(iArr);
    if (iArr.items) {
      put(iArr.items, arrN, levelN);
    }
  }
};

const cleer = (arr) => {
  for (const iArr of arr) {
    if (iArr.items) {
      delete iArr.items;
    }
  }
  return arr;
};

const groupBy = (arr, arrCol, arrFunc) => {
  const arrN = groupByN(arr, arrCol);
  groupByY(arrN, arrFunc);

  return arrN;
};

export async function er(s) {
  const res = groupBy(s, ["team", "merch"], {
    total_days: sum,
    total_visits_add: sum,
    total_visits: sum,
    total_visits_all: sum,
    total_days_all: sum,
  });

  let resN = [];
  put(res, resN);
  resN = cleer(resN);

  let Excel = require("exceljs");

  let wb = new Excel.Workbook();
  let ws = wb.addWorksheet();

  ws.properties.outlineLevelRow = 4;
  ws.properties.outlineProperties = {
    summaryBelow: false,
    summaryRight: false,
  };

  const style = {
    border: {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    },
  };

  ws.columns = [
    { header: "Команда", key: "team", width: 32, style },
    { header: "Сотрудник", key: "merch", width: 32, style },
    { header: "Дата", key: "date", width: 16, style },
    { header: "Количество дней", key: "total_days", width: 10, style },
    { header: "Не по машруту", key: "total_visits_add", width: 10, style },
    { header: "По маршруту", key: "total_visits", width: 10, style },
    { header: "Всего визитов", key: "total_visits_all", width: 10, style },
    { header: "Всего", key: "total_days_all", width: 10, style },
  ];

  for (const iResN of resN) {
    const row = ws.addRow(iResN);
    row.outlineLevel = iResN.outlineLevel;
    for (let i = 1; i < row.cellCount + 1; i++) {
      if (row.outlineLevel === 1) {
        row.getCell(i).fill = {
          type: "pattern",
          pattern: "darkTrellis",
          fgColor: { argb: "00FFFFFF" },
          bgColor: { argb: "00FBCEB1" },
        };
      } else if (row.outlineLevel === 2) {
        row.getCell(i).fill = {
          type: "pattern",
          pattern: "darkTrellis",
          fgColor: { argb: "00FFFFFF" },
          bgColor: { argb: "00FFDB58" },
        };
      }
    }
  }

  wb.xlsx.writeBuffer().then(function (buffer) {
    // done
    const blob = new Blob([buffer], { type: "applicationi/xlsx" });
    saveAs(blob, "myexcel.xlsx");
  });
}

export async function exportToXlsx(gridElement, fileName) {
  const [{ utils, writeFile }, { head, body, foot }] = await Promise.all([
    import("xlsx"),
    getGridContent(gridElement),
  ]);
  const wb = utils.book_new();
  const ws = utils.aoa_to_sheet([...head, ...body, ...foot]);
  utils.book_append_sheet(wb, ws, "Sheet 1");
  writeFile(wb, fileName);
}

async function getGridContent(gridElement) {
  const { renderToStaticMarkup } = await import("react-dom/server");
  const grid = document.createElement("div");
  grid.innerHTML = renderToStaticMarkup(
    cloneElement(gridElement, {
      enableVirtualization: false,
    })
  );

  const getRows2 = (selector) => {
    return getCells(grid.querySelectorAll(selector));
  };
  const getCells = (dom) => {
    const arr = Array.from(dom);

    for (const it of arr) {
      const dom_new = it.querySelectorAll(".rdg-cell");
      getCells(dom_new);
    }
  };

  getRows2(".rdg-row:not(.rdg-summary-row)");

  return {
    head: getRows(".rdg-header-row"),
    body: getRows(".rdg-row:not(.rdg-summary-row)"),
    foot: getRows(".rdg-summary-row"),
  };

  function getRows(selector) {
    return Array.from(grid.querySelectorAll(selector)).map((gridRow) => {
      return Array.from(gridRow.querySelectorAll(".rdg-cell")).map(
        (gridCell) => {
          return gridCell.innerText;
        }
      );
    });
  }
}
